<template>
  <div class="navbar navbar-expand-md navbar-dark">
    <div class="d-flex justify-content-between align-items-center navbar-brand">
      <router-link
        to="/"
        class="d-inline-block"
      >
        <img
          v-if="plan.group"
          alt
          :src="require(`@/assets/images/logo-${this.plan.group}.png`)"
          width=""
        >
      </router-link>
      <a
        href="javascript:void(0);"
        class="hamberger navbar-nav-link sidebar-control sidebar-main-toggle d-none d-md-block"
      >
        <i class="icon-paragraph-justify3" />
      </a>
    </div>
    <h1 class="diff" />
    <div class="align-items-center d-flex flex-grow-1 justify-content-end mr-2">
      <template v-if="plan.group == 'gosell' && plan.series == 'free' || planTrial == true || planEndsAt <= 0">
        <router-link
          :to="{ name: 't.a.premium.subscriptions' }"
          role="button"
          class="btn btn-primary btn-lg"
        >
          <i class="fas fa-medal mr-2" />{{ $t("Upgrade Plan") }}
        </router-link>
      </template>
      <template v-else>
        <div
          v-if="planEndsAt >= 8 && planEndsAt <= 15 || planEndsAt >= 1 && planEndsAt <= 7"
          class="px-2 py-1 border-1 rounded"
          :class="planEndsAt >= 8 && planEndsAt <= 15 ? 'plan-expires-in-15days' : planEndsAt >= 1 && planEndsAt <= 7 ? 'plan-expires-in-7days' : ''"
          style="cursor: pointer !important;"
          @click="renewPlanSubscriptions()"
        >
          <i class="fa-solid fa-envelope-open-dollar mr-1" />
          {{ $t("Plan Expires In") }} {{ planEndsAt }} {{ $t('Days') }}
        </div>
      </template>
    </div>


    <div class="d-md-none">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbar-mobile"
      >
        <i class="icon-tree5" />
      </button>
      <button
        class="navbar-toggler sidebar-mobile-main-toggle ml-2"
        type="button"
      >
        <i class="icon-paragraph-justify3" />
      </button>
    </div>

    <div
      class="collapse navbar-collapse justify-content-between flex-row-reverse flex-grow-0"
      id="navbar-mobile"
    >
      <!-- <ul class="navbar-nav">
            <li class="nav-item">
                <a href="javascript:void(0);" class="
              navbar-nav-link
              sidebar-control sidebar-main-toggle
              d-none d-md-block
            ">
                    <i class="icon-paragraph-justify3"></i>
                </a>
            </li>
            </ul>-->
      <ul class="navbar-nav">
        <li class="nav-item dropdown d-md-none">
          <a
            href="#"
            class="dropdown-toggle navbar-nav-link"
            data-toggle="dropdown"
          >
            <i class="fas fa-globe-asia mr-2" />
            {{ $t(title) }}
            <!-- <img :src="$storeIndex.getImageSrc('lang/' + lang)" class="img-flag mr-2" alt=""> {{title}} -->
          </a>
          <div class="dropdown-menu">
            <a
              v-for="(value, key) in localList"
              :name="key"
              :key="`lang-${key}`"
              @click="selectLang(key)"
              class="dropdown-item"
              href="javascript:void(0);"
            >
              <img
                :src="$storeIndex.getImageSrc('lang/' + key)"
                class="img-flag rounded-round"
                style="max-height: 16px; width: 16px;"
                alt
              >
              {{ $t(value) }}
            </a>
          </div>
        </li>

        <li class="nav-item dropdown">
          <a
            href="javascript:void(0);"
            data-toggle="dropdown"
            @click="loadWalletTransactions()"
            class="navbar-nav-link dropdown-toggle caret-0"
            v-tooltip:bottom="`${$t('_TopMenu.Shipping Credit')}`"
          >
            <i class="fas fa-wallet mr-2" />
            ฿{{ tenant.wallet_shipment | formatNumber }}
            <span class="d-md-none ml-2">{{ $t("Credit Balance") }}</span>
            <!-- <span class="badge badge-pill bg-warning-400 ml-auto ml-md-0">{{walletTransaction.length}}</span> -->
          </a>
          <div
            class="dropdown-menu dropdown-menu-right dropdown-content wmin-md-350"
            ref="dropdownMenuWalletTransaction"
          >
            <div :class="['dropdown-content-header', loadingWalletTransaction? 'loading': '']">
              <span class="font-weight-semibold">{{
                $t("Credit Balance")
              }}</span>
              <!-- <a href="javascript:void(0)" @click="reload" class="text-default"><i class="icon-sync"></i></a> -->
            </div>
            <div
              class="dropdown-content-body dropdown-scrollable"
            >
              <div class="media mb-3 align-items-center">
                <div class="mr-3 btn bg-success rounded-round btn-icon btn-lg">
                  <span class="letter-icon">
                    <i class="fas fa-wallet" />
                  </span>
                </div>
                <div class="media-body">
                  <div class="header-elements-inline">
                    <router-link :to="{ name: 't.a.account-setting' }">
                      <h5 class="font-weight-semibold text-grey-600">
                        <span class="text-muted">{{
                          $t("Total Balance")
                        }}</span>
                        <br>
                        ฿{{ tenant.wallet_shipment | formatNumber }}
                      </h5>
                    </router-link>
                    <span>
                      <a href="/app/account-setting/shippingcredit">
                        <button class="btn btn-primary">
                          <i class="fas fa-credit-card mr-2" />{{ $t("Add Credits") }}
                        </button>
                      </a>
                    </span>
                  </div>
                </div>
              </div>
              <ul
                class="media-list"
              >
                <li
                  class="media"
                  v-for="(val, key) in walletTransaction.slice(0, 5)"
                  :key="'wallet' + key"
                >
                  <div class="mr-3 btn bg-light rounded-round btn-icon btn-lg">
                    <span class="letter-icon">
                      <i
                        :class="[
                          'fas text-grey-94AFB6',
                          val.txn_type == 'deposit' ? 'fa-arrow-up' : 'fa-arrow-down',
                        ]"
                      />
                    </span>
                  </div>
                  <div class="media-body">
                    <div class="media-title">
                      <a
                        href="#"
                        class
                      >
                        <span class="font-weight-semibold text-grey-94AFB6">{{
                          val.txn_type == "deposit" ? $t("Deposit") : $t("Withdrawal")
                        }}</span>
                        <span
                          class="text-muted float-right font-size-sm text-right"
                        >
                          {{ convertTimezone(val.created_date) }}
                          <br>
                          <span
                            :class="[
                              'font-size-base',
                              val.txn_type == 'deposit' ? 'text-success' : 'text-danger',
                            ]"
                          >
                            <span v-if="val.txn_type == 'deposit'">+</span>
                            <span v-else>-</span>
                            ฿{{ (val.txn_type == 'deposit' ? val.deposit: val.withdraw) | formatNumber }}
                          </span>
                        </span>
                      </a>
                    </div>
                    <span class="text-dark">{{ walletDesctipytion(val) }}</span>
                  </div>
                </li>
              </ul>
            </div>
            <div class="dropdown-content-footer p-0">
              <a
                href="/app/account-setting/shippingbilling"
                class="
                  btn btn-primary
                  border-0
                  py-2
                  rounded-0
                  text-center
                  w-100
                "
              >
                {{ $t("See more details") }}
              </a>
              <!-- <router-link :to="{name: 't.a.account-setting'}" class="btn btn-light border-0  py-2 rounded-0   text-center text-grey w-100" :data-original-title="$t('Add Fund')">{{$t('Add Fund')}}</router-link> -->
            </div>
          </div>
        </li>

        <li class="nav-item dropdown d-flex align-items-center justify-content-center">
          <a
            v-if="!gochatLoading"
            href="javascript:void(0);"
            @click="gotoGoChat()"
            class="navbar-nav-link dropdown-toggle caret-0"
            v-tooltip:bottom="`${$t('_TopMenu.Chat')}`"
          >
            <span>
              <i class="fas fa-comments" />
            </span>
          </a>
          <div
            v-else-if="gochatLoading"
            class="spinner-border spinner-border-sm text-light"
            role="status"
            style="margin: .875rem 1rem;"
          >
            <span class="sr-only">{{ $t("Loading...") }}</span>
          </div>
        </li>

        <li class="nav-item dropdown">
          <a
            href="javascript:void(0);"
            @click="showModalShippingRate()"
            class="navbar-nav-link dropdown-toggle caret-0"
            data-toggle="modal"
            data-target="#modal-shipping-rate"
            v-tooltip:bottom="`${$t('_TopMenu.Shipping Calculator')}`"
          >
            <span>
              <i class="fas fa-calculator" />
              <!-- {{ $t("_Topbar.Shipping Rate") }} -->
            </span>
          </a>
        </li>

        <li class="nav-item dropdown">
          <a
            href="javascript:void(0);"
            class="navbar-nav-link dropdown-toggle caret-0"
            data-toggle="dropdown"
            v-tooltip:bottom="`${$t('_TopMenu.Quick Access')}`"
          >
            <span>
              <i class="fas fa-plus-circle" />
              <!-- {{ $t("Shortcut") }} -->
            </span>
            <!-- <span class="d-md-none ml-2">Messages</span> -->
            <!-- <span class="badge badge-pill bg-warning-400 ml-auto ml-md-0">2</span> -->
          </a>

          <div class="dropdown-menu dropdown-menu-right dropdown-content wmin-md-250">
            <div class="dropdown-content-header py-2">
              <span>{{ $t('Quick Access') }}</span>
            </div>

            <div class>
              <a
                href="/app/account-setting/shippingcredit"
                class="dropdown-item"
              >
                <span
                  class="btn bg-light rounded-round btn-icon btn-lg mr-2 text-grey-94AFB6"
                >
                  <i
                    class="fas fa-wallet"
                    style="width:17.5px;"
                  />
                </span>

                <div class="media-body">
                  <div>
                    <span
                      class="font-weight-semibold text-body"
                    >
                      {{ $t('Add Fund') }}
                    </span>
                  </div>
                  <span class="text-muted">{{ $t('Credit Balance') }}</span>
                </div>
              </a>

              <a
                href="/app/orders/index?modal=1"
                class="dropdown-item"
              >
                <span
                  class="btn bg-light rounded-round btn-icon btn-lg mr-2 text-grey-94AFB6"
                >
                  <i class="fas fa-shopping-cart" />
                </span>

                <div class="media-body">
                  <div>
                    <span
                      class="font-weight-semibold text-body"
                    >
                      {{ $t('Add Order') }}
                    </span>
                  </div>
                  <span class="text-muted">{{ $t('Create new order') }}</span>
                </div>
              </a>

              <a
                href="/app/customer?modal=1"
                class="dropdown-item"
              >
                <span
                  class="btn bg-light rounded-round btn-icon btn-lg mr-2 text-grey-94AFB6"
                >
                  <i class="fas fa-users" />
                </span>

                <div class="media-body">
                  <div>
                    <span
                      class="font-weight-semibold text-body"
                    >
                      {{ $t('Add Customer') }}
                    </span>
                  </div>
                  <span class="text-muted">{{ $t('Create new customer') }}</span>
                </div>
              </a>
              <a
                href="/app/products?modal=1&create=1"
                class="dropdown-item"
              >
                <span
                  class="btn bg-light rounded-round btn-icon btn-lg mr-2 text-grey-94AFB6"
                >
                  <i
                    class="fas fa-box"
                    style="width:17.5px;"
                  />
                </span>

                <div class="media-body">
                  <div>
                    <span
                      class="font-weight-semibold text-body"
                    >
                      {{ $t('Add Product') }}
                    </span>
                  </div>
                  <span class="text-muted">{{ $t('Create new simple product') }}</span>
                </div>
              </a>
            </div>
          </div>
        </li>
        <li class="nav-item dropdown">
          <a
            href="javascript:void(0);"
            @click="showModalNotificationHistory()"
            class="navbar-nav-link dropdown-toggle caret-0"
            data-toggle="modal"
            data-target="#modal-notification-history"
            v-tooltip:bottom="`${$t('_TopMenu.Notification')}`"
          >
            <span>
              <i class="fa-solid fa-bell-exclamation font-size-lg" />
            </span>
            <span
              style="right: -3px; top: 5px;"
              class="badge bg-danger-400 badge-pill badge-float left-auto"
            >
              {{ unRead }}
            </span>
          </a>
        </li>
        <li
          class="nav-item dropdown dropdown-user overflow-show-lang"
          id="MenuSetting"
        >
          <a
            href="javascript:void(0);"
            class="navbar-nav-link d-flex align-items-center dropdown-toggle profile-tab"
            data-toggle="dropdown"
            id="dropdownMenuSetting"
            ref="dropdownMenuSetting"
          >
            <img
              :src="tenant.logo"
              class="fix-logosize-shop rounded-circle mr-2"
              height="34"
              width="34"
              alt
              v-if="tenant.logo != ''"
            >
            <span
              class="icon-store-custom mr-2"
              style="line-height: 0px;"
              v-else
            >
              <i class="fas fa-store" />
            </span>
            <div class="media-body">
              <h6 style="margin-top: -4px">{{ tenant.name.length > 20 ? tenant.name.slice(0, 20) + "..." : tenant.name }}</h6>
              <div style="margin-top: -15px">
                <span style="font-size: 12px">{{ user.role }}</span>
              </div>
            </div>
          </a>

          <div
            class="dropdown-menu wmin-md-250"
            v-if="!tenantTab"
          >
            <div
              class="dropdown-item cursor-pointer"
              @click="redirectUrl('general')"
            >
              <div class="media-body d-flex align-items-center">
                <img
                  v-if="user.image_url"
                  :src="user.image_url"
                  class="fix-logosize"
                >
                <img
                  v-else
                  :src="require('@/assets/images/no-image-user.png')"
                  class="fix-logosize"
                >
                <div class="ml-2">
                  <h6 class="media-title mb-0 font-weight-bold name-menu-tenant">
                    {{ user.name.charAt(0).toUpperCase() + user.name.slice(1) }}
                  </h6>
                  <div>
                    <span class="mr-1">
                      <span class="font-size-base text-muted">
                        {{ $t("View Profile") }}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="dropdown-divider" />
            <div
              class="show-merchant-id"
              @mouseenter="is_hover_merchant = true"
              @mouseleave="is_hover_merchant = false"
            >
              <span class="mr-1">{{ $t("Merchant Code") }} : {{ tenant.tenancy_db_connection ? this.formatTenancyDB(tenant.tenancy_db_connection) + "-" : "" }}{{ tenant.code }} </span>
              <i
                class="fa-regular fa-copy text-info pointer"
                v-if="is_hover_merchant"
                v-clipboard:copy="merchantCode"
                v-clipboard:success="merchantCopy"
              />
            </div>
            <div class="dropdown-divider" />
            <div
              class="dropdown-submenu dropdown-submenu-left"
            >
              <div
                class="dropdown-item"
                @mouseenter="loadStores()"
              >
                <i class="fa-solid fa-store" />
                {{ $t("_Topbar.My Stores") }}
              </div>

              <div
                :class="['dropdown-menu', 'dropdown-menu-sm',loadingStores? 'loading': '']"
                :style="loadingStores? 'height: 200px': ''"
              >
                <div
                  class="dropdown-item align-items-center d-flex pl-lg-2 cursor-pointer list-group-item-action"
                  @click="redirectUrl('store')"
                >
                  <span class="image-store-switch d-inline-flex align-items-center justify-content-center mr-2">
                    <i class="fa-solid fa-grid-2 fa-1x" />
                  </span>
                  <span class=" font-size-lg font-weight-semibold">
                    {{ $t('View All Stores') }}
                  </span>
                </div>
                <div
                  class="dropdown-item"
                  v-for="(store, i) in canAccess.slice(0, limitStore)"
                  :key="store.id"
                  :id="'store-' + store.id"
                  :class="['align-items-center d-flex pl-lg-2 cursor-pointer list-group-item-action', canAccess.slice(0, limitStore).length == (i+1) ? '' : '']"
                  @click="handleLogin(store)"
                >
                  <img
                    class="image-store-switch"
                    :src="store.logo"
                    v-if="store.logo"
                  >
                  <span
                    class="icon-store-switch mr-2"
                    v-else
                  >
                    <i class="fas fa-store" />
                  </span>
                  <span
                    :id="'submenu-'+replaceSpaceAndSpecialChars(store.name)"
                    class="store-name-topmenu-submenu"
                    style=""
                  >
                    {{ store.name }}
                  </span>
                  <span
                    :id="replaceSpaceAndSpecialChars(store.name)"
                    class="badge badge-success-status ml-1"
                  />
                </div>
              </div>
            </div>

            <router-link
              class="dropdown-item"
              :to="{ name: 't.a.account-setting.shippingcredit' }"
            >
              <i
                class="fa-solid fa-wallet fa-1x"
                style="margin-right: 0.685rem;"
              />
              {{ $t("Shipping Credit") }}
            </router-link>
            <router-link
              class="dropdown-item"
              :to="{ name: 't.a.account-setting.smscredit' }"
            >
              <i
                class="fa-solid fa-comment-sms fa-1x"
                style="margin-right: 0.685rem;"
              />
              {{ $t("SMS Credit") }}
            </router-link>
            <router-link
              v-if="features.includes('feature-slip-verification')"
              class="dropdown-item"
              :to="{ name: 't.a.service-credit.index' }"
            >
              <i
                class="fa-solid fa-sack-dollar fa-1x"
                style="margin-right: 0.685rem"
              />
              {{ $t("Service Credit") }}
            </router-link>
            <router-link
              class="dropdown-item"
              :to="{ name: 't.a.premium.subscriptions' }"
            >
              <i
                class="fas fa-envelope-open-dollar fa-1x"
                style="margin-right: 0.685rem"
              />
              {{ $t("Premium Subscriptions") }}
            </router-link>
            <a
              v-if="plan.group == 'gosell'"
              class="dropdown-item align-items-center justify-content-between"
              @mouseenter="is_hover_track = true"
              @mouseleave="is_hover_track = false"
            >
              <div
                @click="checkTrackingStatus"
              >
                <i
                  class="fa-solid fa-barcode-read fa-1x"
                  style="margin-right: 0.685rem"
                />
                {{ $t("Link Track & Trace") }}
              </div>
              <div style="cursor: pointer">
                <i
                  class="fa-light fa-copy fa-1x"
                  style="color: #2196f3; z-index: 999;"
                  v-if="is_hover_track"
                  v-clipboard:copy="track_code"
                  v-clipboard:success="trackingCopy"
                />
              </div>
            </a>
            <!-- <a :href="accountUrl" class="dropdown-item"><i class="icon-cog5"></i> {{$t("Account Setting")}}</a> -->
            <div class="dropdown-divider" />
            <div class="dropdown-submenu dropdown-submenu-left">
              <a
                href="#"
                class="dropdown-item"
              >
                <i class="fas fa-globe-asia fa-1x" />
                {{ $t(title) }}
                <!-- <img :src="$storeIndex.getImageSrc('lang/' + lang)" class="img-flag mr-2" alt=""> {{title}} -->
              </a>
              <div class="dropdown-menu dropdown-menu-sm">
                <a
                  v-for="value in localList"
                  :name="value.code"
                  :key="`lang-${value.code}`"
                  @click="selectLang(value.code)"
                  class="dropdown-item"
                  href="javascript:void(0);"
                >
                  <img
                    :src="$storeIndex.getImageSrc('lang/' + value.code)"
                    class="img-flag rounded-round"
                    alt
                  >
                  {{ $t(value.name) }}
                </a>
              </div>
            </div>
            <a
              href="javascript:void(0);"
              @click="logout()"
              class="dropdown-item"
            >
              <i class="icon-switch2" />
              {{ $t("Log Out") }}
            </a>
          </div>
          <div
            class="dropdown-menu wmin-md-250 tenant-tab"
            v-else
          >
            <div
              class="dropdown-item"
              @click="closeTenantTab"
            >
              <i class="fa-solid fa-arrow-left mr-3" /><b>{{ $t("_Topbar.My Stores") }}</b>
            </div>
            <div class="dropdown-divider" />
            <div
              class="dropdown-item"
              v-for="(store, i) in canAccess.slice(0, limitStore)"
              :key="store.id"
              :id="'store-' + store.id"
              :class="['align-items-center d-flex pl-lg-2 cursor-pointer list-group-item-action', canAccess.slice(0, limitStore).length == (i+1) ? '' : '']"
              @click="handleLogin(store)"
            >
              <!-- <img
                class="image-store-switch"
                :src="store.logo"
                v-if="store.logo != ''"
              >
              <span
                class="icon-store-switch mr-2"
                v-else
              >
                <i class="fas fa-store" />
              </span> -->
              {{ store.name }}
              <span
                :id="replaceSpaceAndSpecialChars(store.name)"
                class="badge badge-success-status ml-1"
              />
            </div>
          </div>
        </li>
      </ul>
    </div>
    <modal-shipping-rate v-if="shippingRateModal" />
    <modalNotificationHistory v-if="notificationHistoryModal" />
    <ModalPayForPlan
      ref="modalPayForPlan"
      :tenant-id="tenant.id"
    />
  </div>
</template>

<script>
import CentralApi from "@/services/endpoint/central.service";
import TenantAuth from "@/services/auth.tenant.service";
import Api from "@/services/endpoint/tenant.service";
import Cookies from "js-cookie";

// import config from '@/configure/index';
import { localSave, localRead } from "@/store/lang";
import modalShippingRate from "./ModalShippingRate.vue";
import modalNotificationHistory from "./ModalNotificationHistory.vue";
import numeral from "numeral";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import moment from "moment";
import ModalPayForPlan from "@/components/tenancy/admin/account-setting/premium-subscriptions/payment-modal/ModalPayForPlan";
import ModalRestock from "./restock/ModalRestock";
import ModalValidateRestock from "./restock/ModalValidateRestock";
import AdjustmentsModal from "./restock/AdjustmentsModal";
import eventBus from '@/plugins/eventBus';
import WebSocket from "isomorphic-ws";
import languages from "@/plugins/static/language.json";

export default {
  name: "TopMenu",
  components: {
    modalShippingRate,
    modalNotificationHistory,
    ModalPayForPlan,
    ModalRestock,
    ModalValidateRestock,
    AdjustmentsModal
  },
  data() {
    return {
      tenant: JSON.parse(Cookies.get('tenant')),
      features: JSON.parse(Cookies.get('features')),
      user: JSON.parse(Cookies.get('user')),
      package: "goship", //default package for all
      plan: JSON.parse(Cookies.get('plan')),
      is_hover_merchant: false,
      is_hover_track: false,
      track_code: window.location.origin + "/chk-status",
      accountUrl: process.env.CENTRAL_ACC_URL,
      centralApiPort: process.env.CENTRAL_API_PORT,
      centralApiRoot: process.env.CENTRAL_API_ROOT,
      tenantApiRoot: process.env.TENANT_API_ROOT,
      lang: localRead("local"),
      localList: languages,
      walletTransaction: [],
      onload: false,
      shippingRateModal: false,
      notificationHistoryModal: false,
      tenantTab: false,
      limitStore: 20,
      currentLogin: "",
      protocal: "",
      canAccess: [],
      unRead: JSON.parse(Cookies.get('user')).unread,
      setting: [],
      planTrial: JSON.parse(Cookies.get('plan')).trial,
      planEndsAt: 16,
      planEndDate:'',
      allDataPlan:[],
      loadingStores:true,
      loadingWalletTransaction:true,
      websocket: null,
      /* start premium subscription */
      isLoading: false,
      hasPermission: false,
      action: "change",
      planSerie: "free",
      showPlan: false,
      payAnnuallySave50Per: false,
      planSubscription: {},
      upgrade: true,
      /* end premium subscription */
      gochatLoading: false,
      isRestockModal: false,
      isRestockValidateModal: false,
      isAdjustmentModal: false,
      adjustment: {},
      products: []

    };
  },
  computed: {
    title() {
      return this.localList.find(x => x.code === this.lang).name
    },
    merchantCode() {
      return this.$t("_TopMenu.Merchant") +
        " " +
        this.tenant.name +
        " : " +
        (this.tenant.tenancy_db_connection ? this.formatTenancyDB(this.tenant.tenancy_db_connection) + "-" : "") + this.tenant.code;
    },
    listUnRead() {
      return this.$store.state.user.unRead;
    },
  },
  async created() {

    if(!localStorage.getItem('isCypress')) {
      // open eventBus for websocket
      eventBus.on('walletShipmentBalance', payload => {
        const { data } = payload
        this.tenant.wallet_shipment = data.wallet_shipment;
        Cookies.set('tenant', JSON.stringify(this.tenant), { domain: '.' + process.env.CENTRAL_API_ROOT });

        eventBus.off('walletShipmentBalance', payload)
      })
    }
  },
  methods: {
    showModal() {
      $("#modal-notification-history").modal("hide");
      $('#modal-notification-history').on('hidden.bs.modal', (e) => {
        this.$parent.$refs.modalContent.isRestockModal = true;
        this.$nextTick(() => {
          $("#ModalRestock").modal("show")
        })
      })
    },
    merchantCopy(e) {
      this.$toastr.Add({
        type: "success",
        title: "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success"),
        msg: this.$t("Copy merchant code. success."),
        clickClose: true,
        timeout: 2000,
        position: "toast-top-right",
      });
    },
    async loadStores() {
      this.loadingStores = true;
      this.canAccess = [];
      await Api.StoresV2.getStores('?limit=5&sort=last_login|desc').then((res) => {
        this.canAccess = res.data.data;
        this.loadingStores = false;
      }).catch((err) => {
        console.log(err, 'err');
      });
    },
    async loadWalletTransactions() {
      const dropdownMenuWalletTransaction = this.$refs.dropdownMenuWalletTransaction;
      if (!dropdownMenuWalletTransaction.classList.contains('show')) {
        this.loadingWalletTransaction = true;
        this.walletTransaction = [];
        let queryString = "?limit=20";
        await Api.WalletV2.getTransactions(queryString).then((res) => {
          this.walletTransaction = res.data.data;
          this.loadingWalletTransaction = false;
        }).catch((err) => {
          console.log(err);
        });
      }
    },
    trackingCopy(e) {
      this.$toastr.Add({
        type: "success",
        title: "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success"),
        msg: this.$t("Copy link success"),
        clickClose: true,
        timeout: 2000,
        position: "toast-top-right",
      });

    },
    checkTrackingStatus() {
      window.open(
        this.track_code,
        "_blank"
      );
    },
    walletIsLanguage(Object) {
      let associate = null;
      if(Object.type == 'IN') {
        if(Object.description.indexOf('เติมเงินโดย Admin') != -1) {
          associate = this.$t('top up by') + ' Admin';
          associate += Object.description.split("เติมเงินโดย Admin")[1];
        } else if(Object.carrier == '') {
          if(Object.description.indexOf('เติมเงินค่าบริการขนส่ง') != -1) {
            associate = this.$t('top up transportation charges');
          } else {
            associate = Object.description.split(" (หมายเลขคำสั่งซื้อ")[0];
          }
          if(Object.ordersn != '') {
            associate += ' (' + this.$t('Order No.') + ' ' + Object.ordersn + ')';
          }
        } else {
          if(Object.description.indexOf('คืนเงินเนื่องจากยกเลิกพัสดุ') != -1) {
            associate = this.$t('Refund due to parcel cancellation');
          } else if(Object.description.indexOf('คืนเงินหลังคิดค่าบริการตามจริง') != -1) {
            associate = this.$t('Refund after actual service charge');
          }
          associate += ' ' + Object.carrier + ' (' + this.$t('Tracking') + ' ' + Object.ordersn + ')';
        }
      } else if(Object.type == 'OUT') {
        if(Object.description.indexOf('ถอนเงินโดย Admin') != -1) {
          associate = this.$t('withdraw money by') + ' Admin';
          associate += Object.description.split("ถอนเงินโดย Admin")[1];
        } else if(Object.carrier != '' && Object.description.indexOf('หักเงินค่าบริการขนส่ง') != -1) {
          associate = this.$t('Less transportation charges') + ' ' + Object.carrier + ' (' + this.$t('Tracking') + ' ' + Object.ordersn + ')';
        }
      }
      return associate;
    },
    walletDesctipytion(Object) {
      if (Object.order_number == "" && Object.estimate_carrier == ""  && Object.actual_carrier == "" ) {
        return (Object.txn_type == 'deposit')? this.$t('top up by') + ' Admin': this.$t('withdraw money by') + ' Admin';
      }
      if(Object.order_number) {
        if(Object.order_number && Object.payment_remark){
          return Object.payment_remark + " (" + this.$t('Order No.') + " " + Object.ordersn + ")";
        }
        return this.$t('top up transportation charges') + " (" + this.$t('Order No.') + " " + Object.ordersn + ")";
      }

      if (Object.txn_type == 'deposit') {
        if (Object.actual_carrier) {
          return this.$t('Refund after actual service charge') + " " + Object.actual_carrier + ' (' + this.$t('Tracking') + Object.ordersn + ")";
        }
        return this.$t('Refund due to parcel cancellation') + " " + Object.estimate_carrier + ' (' + this.$t('Tracking') + Object.ordersn + ")";
      } else {
        return this.$t('Less transportation charges') + ' ' + (Object.actual_carrier != ''? Object.actual_carrier: Object.estimate_carrier) + ' (' + this.$t('Tracking') + ' ' + Object.ordersn + ')';
      }
    },
    async reload() {
      this.onload = true;
      // await this.getWalletBalanceAll();
      // await this.getWalletTransactionShipment();
      this.$nextTick(() => {
        this.onload = false;
      });
    },
    selectLang(lang) {
      localSave("local", lang);
      location.reload();
    },
    showModalShippingRate() {
      this.shippingRateModal = false;
      this.$nextTick(() => {
        this.shippingRateModal = true;
      });
    },
    async getCurentUser() {
      let user = JSON.parse(Cookies.get('user'));
      this.user.name = user.name;
      this.user.image_url = user.profile_url;
      this.user.role = user.roles[0];
      if (this.user.name.length > 25) {
        this.user.name = this.user.name.substring(0, 25);
      }
      if (this.user.role.length > 30) {
        this.user.role = this.user.role.substring(0, 30) + "..";
      }

    },
    getPlanExpired() {
      let plan = JSON.parse(Cookies.get('plan'));
      let dateEndPlanActive = plan.expire_date;

      let toDay = new Date();
      let planTodayDate = convertTimezone.utcToLocal(toDay);
      this.planEndDate = convertTimezone.utcToLocal(dateEndPlanActive);
      let startDate = moment(planTodayDate);
      let endDate = moment(this.planEndDate);
      let duration = moment.duration(endDate.diff(startDate));
      let daysEnds = duration.asDays();
      this.planEndsAt = Math.round(daysEnds);
    },
    async logout() {
      await Api.Tenant.logOut();
      await TenantAuth.logout();
      await CentralApi.Auth.logOut();
      this.$cookie.remove("centralToken", {
        domain: "." + process.env.CENTRAL_API_ROOT,
      });
      this.$cookie.remove("tenantToken", {
        domain: "." + process.env.CENTRAL_API_ROOT,
      });
      location.href = process.env.CENTRAL_APP_URL;
    },
    async getWalletTransactionShipment() {
      let queryString = "?per_page=20";
      let resp = await Api.User.getWalletTransactionShipment(queryString);
      if (!resp.status) return;
      if (resp.data.data.code == 0) {
        this.walletTransaction = resp.data.data.data;
      }
      return;
    },
    showModalNotificationHistory() {
      this.notificationHistoryModal = false;
      this.$nextTick(() => {
        this.notificationHistoryModal = true;
      });
    },
    async openWebSocketWalletShipment(){
      let ws = this.websocket = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
      let vm = this;

      ws.onopen = function open() {
        ws.send(JSON.stringify({
          "data": {
            clientUid: `websocket.channel.all.0-${vm.tenant.id}`
          },
          "event": "subscribe"
        }))
      }

      ws.onmessage = e => {
        const {data, event} = JSON.parse(e.data)

        if(data.clientUid == `websocket.channel.all.0-${vm.tenant.id}` && event === 'request.wallet.shipment') {
          if (data.status) {
            vm.tenant.wallet_shipment = data.data.wallet_shipment;
            Cookies.set('tenant', JSON.stringify(vm.tenant), { domain: '.' + process.env.CENTRAL_API_ROOT });
          }
        }
        if(data.clientUid == `websocket.channel.all.0-${vm.tenant.id}` && event === 'wms.service.store.create') {
          Cookies.set('wmsServiceId', JSON.stringify(data.wms_id), { domain: '.' + process.env.CENTRAL_API_ROOT });
        }
        if (data.clientUid == `websocket.channel.all.0-${vm.tenant.id}` && event === 'ping') {
          ws.send(JSON.stringify({
            "data": {
              "clientUid": `websocket.channel.all.0-${vm.tenant.id}`
            },
            "event": `pong`
          }))
        }
      }

      ws.onclose = event => {
        console.error(`websocket closed`)
        this.socket()
      }
    },
    // แก้ไขเป็นเปิด web socket
    async getNotificationUnread() {
      let response = await Api.Notification.getNotificationUnread();
      this.unRead = response.data.meta.total;
    },
    convertTimezone(date) {
      return date != null && new Date(date) instanceof Date && !isNaN(new Date(date))
        ? convertTimezone.utcToLocal(date)
        : "-";
    },
    openTenantTab() {
      this.tenantTab = true;
      if (this.tenantTab == true) {
        setTimeout(function () {
          $("#dropdownMenuSetting").dropdown("show");
        }, 1);
      }
    },
    closeTenantTab() {
      this.tenantTab = false;
      if (this.tenantTab == false) {
        setTimeout(function () {
          $("#dropdownMenuSetting").dropdown("show");
        }, 1);
      }
    },
    async getAccess() {
      this.canAccess = [];
      let data = await CentralApi.Auth.getAccess('?per_page=5');
      data.data.data.forEach((store) => {
        if ((store.tenant.progress * 100) / 8 == 100) {
          this.canAccess.push(store);
        }
      });
      this.$store.dispatch("user/getAccess", data.data.data);
    },
    storeUpgradeswal(tenantId){
      const self = this;

      const content = this.$t("Your version of the store is no longer supported.<br> Please click update to continue using the store.");

      this.$swal.fire({
          title: this.$t('New Version Available'),
          iconHtml: `<img src="${this.store_upgrade_image}" class="store-need-upgrade-image" />`,
          iconColor: '#2196f3',
          html: this.$t(content),
          showCancelButton: true,
          confirmButtonText: '<i class="mr-1 fas fa-check-circle"></i>' + this.$t('Update'),
          cancelButtonText: this.$t('Cancel'),
          confirmButtonColor: "#1F88E5",
          buttonsStyling: false,
          customClass: {
              title: 'h5',
              icon: 'no-border-icon',
              html: 'body',
              confirmButton: 'btn btn-primary mr-2',
              cancelButton: 'btn btn-outline-normal'
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: function () {
            return new Promise(resolve => setTimeout(resolve, 800));
          }
      }).then((result) => {
          if (result.isConfirmed) {
            self.redirectUrl('store?code=' + window.btoa(JSON.stringify({tenantId})))
          }
      }).catch((e) => {
          console.error(e.message);
      })
    },
    async handleLogin(store) {
      const request = await CentralApi.AppVersions.checkMigrate(store.id);
      if(request.status == 500) {
        console.error("check store update failed")
        return
      }

      if(request.data.mustMigrate) {
        this.storeUpgradeswal(store.tenant_id)
        return;
      }

      let protocal = this.protocal;
      let tenantApiRoot = this.tenantApiRoot;
      let redirectUrl =
        this.protocal +
        "//" +
        store.domain +
        "." +
        this.centralApiRoot +
        this.centralApiPort;
      if (this.currentLogin === store.domain) {
        window.location.href = redirectUrl;
      } else {
        this.$swal
          .fire({
            title: this.$t("Shop") + " " + store.name,
            iconHtml: '<i class="fa-regular fa-person-to-door"></i>',
            iconColor: "#2196f3",
            html: this.$t("_Topbar.Click confirm to login to your store"),
            showCancelButton: true,
            confirmButtonText:
              '<i class="fas fa-check-circle mr-1"></i>' + this.$t("Confirm"),
            cancelButtonText: this.$t("Cancel"),
            confirmButtonColor: "#1F88E5",
            buttonsStyling: false,
            customClass: {
              title: "h5",
              icon: "no-border-icon",
              html: "body",
              confirmButton: "btn btn-primary mr-2",
              cancelButton: "btn btn-outline-normal",
            },
            focusConfirm: false,
            showLoaderOnConfirm: true,
            preConfirm: function (password) {
              return new Promise((resolve, reject) => {
                CentralApi.Auth.getUserProfile().then(function (response) {
                  let data = response.data.data;
                  let apiUrl =
                    protocal + "//" + store.domain + "." + tenantApiRoot;
                  //console.log(data);
                  TenantAuth.setUrl(apiUrl);
                  TenantAuth.login(data.global_id)
                    .then(function (res) {
                      resolve();
                    })
                    .catch((error) => {
                      console.log(error.response.data.message, "catch");
                      reject(error.response.data.message);
                    });
                });
              });
            },
          })
          .then((result) => {
            //console.log(result, 'then2');
            if (result.isConfirmed) {
              //toastr here
              window.location.href = redirectUrl;
            }
            this.tenantTab = false;
          })
          .catch((error) => {
            console.log(error, "error2");
          });
      }
    },
    redirectUrl(nameUrl) {
      window.location.href = this.accountUrl + "/" + nameUrl;
    },
    // ######## รอกลับมาดู
    async checkIntegrationExpire() {
      let response = await Api.Integration.getIntegrationView('?integration_group_id=3,12')
      // Get the current date and time
      let now = new Date();
      let ref = this;
      $.each(response.data.data, function (key, val) {
        // Set a previous date
        // let previousDate = new Date('2022-12-25T11:25:28.851Z');
        if(val.omni_data !== null){
          let previousDate = new Date(val.omni_data.access_token_expired_date);
          // Calculate the difference in days
          let diffInMilliseconds = previousDate.getTime() - now.getTime();

          // Convert the difference to days
          let diffInDays = diffInMilliseconds / (1000 * 60 * 60 * 24);

          ref.$store.dispatch("integration/getMarketPlaceDateExpire", diffInDays);

          if(diffInDays <= 14 ||
            val.omni_data.status == false){
            ref.$store.dispatch("integration/getMarketPlaceExpire", true);
          }
          return
        }

        if(val.integration_type.code == 'YALECOM' && val.is_standard == 0){
          let integationVoice = val.integration_voice
          const checkstaffIdNull = integationVoice.filter(item => item.staff_id === null);
          if(checkstaffIdNull.length){
            ref.$store.dispatch("integration/getVoiceCallWarning", true);
            return
          }
          const checkstaffIdAccepted = integationVoice.filter(item => (item.staff.deleted_at !== null || item.staff.left_at !== null || item.staff.status === 'blocked'));
          if(checkstaffIdAccepted.length){
            ref.$store.dispatch("integration/getVoiceCallWarning", true);
          }
          return
        }

      });
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    replaceSpaceAndSpecialChars(inputString) {
      // Replace spaces with dashes
      let replacedString = inputString.replace(/\s/g, '-');

      // Convert special characters to ASCII numbers
      replacedString = replacedString.replace(/[^A-Za-z0-9\-ก-ฮเ-์]/g, function(match) {
        return match.charCodeAt(0);
      });

      return replacedString;
    },
    async renewPlanSubscriptions() {
      this.$refs.modalPayForPlan.action = "renew";
      $("#modal_pay_for_plan").modal("show");
      let subscription = await CentralApi.Tenant.getPlanSubscription(this.tenant.id,{ dataReady: true });
      this.$refs.modalPayForPlan.feedData(null, subscription.standardPlanSubscription.plan.plan_serie.id);
    },
    /* end premium subscription */
    gotoGoChat() {
      let showExceed = this.$store.state.user.showExceed;

      if (showExceed.length > 0) {
        $("#alert-exceedlimit").modal('show');
        this.$parent.isShowPagemodal = false;
      }else{
        this.actionGotoChat();
      }
    },
    async actionGotoChat(){
      let queryString = `?language=${localRead("local").toUpperCase() == "TH" ? "THAI" : "ENGLISH"}`
      this.gochatLoading = true;
      try {
        const res = await Api.Integration.autoLoginSocial(queryString);
        if (res.data.success) {
          window.open(res.data.data.url);
          this.gochatLoading = false;
        }
        else {
          this.$toastr.e(this.$t(res.data.message),
            "<i class='fas fa-times-circle mr-2'></i>" + this.$t("Error")
          );
          this.gochatLoading = false;
        }
      } catch (error) {
        console.log(error);
        this.gochatLoading = false;
      }
    },
    async checkPermissionMaskPhone(){
      try {
        if(Cookies.get('mask_phone')) return

        const resCustomer = await Api.Permission.postHasPermission('customer_mark_phone');
        const resOrder = await Api.Permission.postHasPermission('order_mark_phone');
        const resShipment = await Api.Permission.postHasPermission('shipment_mark_phone');
        const resCrm = await Api.Permission.postHasPermission('app_crm_mark_phone');

        const maskPhone = {
          'customer' : resCustomer.data.status,
          'order' : resOrder.data.status,
          'shipment' : resShipment.data.status,
          'crm' : resCrm.data.status
        }
        Cookies.set('mask_phone',JSON.stringify(maskPhone));
      } catch (error) {
        console.log(error);
      }
    },
    formatTenancyDB(name) {
      if (!name) return "";
      const parts = name.split("-");
      const dashCount = parts.length - 1;

      if (dashCount === 1) {
        return parts[0][0].toUpperCase() + parts[1];
      } else if (dashCount === 2) {
        return parts[0][0].toUpperCase() + parts[1][0].toUpperCase() + parts[2];
      } else {
        return name;
      }
    },
    async openWebSocketNotificationUnread() {
      //NotifaicationEvents
      let e = this.listUnRead;
      if(e && e.status){
        this.unRead = e.unreadCount;
        this.user.unread = e.unreadCount;

        delete this.user.login_date
        delete this.user.created_date
        delete this.user.updated_date

        Cookies.set('user', JSON.stringify(this.user), { domain: '.' + process.env.CENTRAL_API_ROOT });
      }
    }
  },
  async mounted() {
    await this.$store.dispatch("websocket/initWebsocket");
    var hasEvents = false;

    $("div.show-merchant-id").click(function () {
      hasEvents = true;
      setTimeout(function () {
        hasEvents = false;
      }, 100);
    });
    $("#MenuSetting").on("hide.bs.dropdown", function (e) {
      if (e.clickEvent && hasEvents) {
        e.preventDefault();
      }
    });
    if(location.pathname.indexOf("app/print/") == -1) {
      this.getCurentUser();
      this.getPlanExpired();
      // if(!localStorage.getItem('isCypress')){
      //   this.openWebSocketNotificationUnread();
      // }
    }
    this.checkPermissionMaskPhone();
  },
  created() {
    this.store_upgrade_image = require("@/assets/images/store_upgrade.png"),
    this.protocal = window.location.protocol;
    let vm = this;
    $(document).on("click", function (event) {
      var $trigger = $(
        ".navbar-nav-link d-flex align-items-center dropdown-toggle"
      );
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        if ($(".tenant-tab.show").length >= 1) {
          vm.tenantTab = false;
        }
      }
    });
  },
  filters: {
    formatNumber: function (value) {
      return numeral(value).format("0,0.00");
      //return parseFloat(value).toFixed(2);
    },
  },
  updated() {
    let vm = this;
    if (vm.tenant.name) {
      const idTenantName = this.replaceSpaceAndSpecialChars(vm.tenant.name);
      $("#" + idTenantName).html(
        '<span class="text-success"><i class="fas fa-check-circle mr-1"></i>' +
          this.$t("Online") +
          "</span>"
      );
      $("#submenu-" + idTenantName).addClass("storeActive");
    }
  },
  watch: {
    "$store.state.user.tenant": {
      handler: async function (nval, oval) {

        this.tenant.wallet_shipment = nval.wallet_shipment;
        Cookies.set('tenant', JSON.stringify(nval), { domain: '.' + process.env.CENTRAL_API_ROOT });

      },
    },
    $refreshTopbarWallet(nval) {
      this.reload();
      // this.getWalletBalanceAll();
      // this.getWalletTransactionShipment();
    },
    isLoading(nval){
      if(nval == false){
        let uri = window.location.search.substring(1);
        let params = new URLSearchParams(uri);
        if (params.get("renewNow")) {
          var self = this;
          setTimeout(function () {
            self.renewPlanSubscriptions();
          }, 1000);
        }
      }
    }
  }
};
</script>

<style scoped>
.fix-logosize {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
}

.icon-store-custom {
  width: 30px;
  height: 30px;
  line-height: 30px;
  background: #ecf0f1;
  border-radius: 100%;
}

.icon-store-switch {
  width: 30px;
  height: 30px;
  min-width: 30px;
  min-height: 30px;
  font-size: 16.5px;
  line-height: 30px;
  background: #ECF0F1;
  color: #B1C5CD;
  border-radius: 30px;
}

.image-store-switch {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
}

.fix-logosize-shop {
  width: 30px;
  height: 30px;
  object-fit: cover;
  border-radius: 50%;
}
.dropdown-item > img {
  max-height: 3rem;
  margin-right: 0.5rem;
}
.store-name-topmenu-submenu {
  font-family: 'Inter', sans-serif !important;
  font-size: 13px;
  font-weight: 400;
  line-height: 30px;
  color: #515151;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.badge-success-status {
  color: #135d3b;
  background-color: #dcf3e8;
  border-color: #36b97d;
}
.profile-role-user {
  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  clear: both;
  font-weight: 400;
  color: #333;
  text-align: inherit;
  background-color: transparent;
  border: 0;
}
.show-merchant-id {
  padding: 0.5rem 1rem;
}
.name-menu-tenant {
  margin-top: -5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 150px;
}
.bg-warning-100{
  background-color: #FDF3E2;
}
.bg-danger-100{
  background-color: #F8E2E0;
}


</style>

<style>
.store-need-upgrade-image {
  height: 110.36825561523438px;
  width: 191.24916076660156px;
}
</style>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/TopMenu.vue